<script setup lang="ts">
  import { computed } from 'vue';
  import { useRouter } from 'vue-router';
  import { Checkbox, Chip } from '@/shared/ui';
  import RecordActionsCell from './RecordActionsCell.vue';
  import type { ModelItem, RecordAction } from '../model/models.types';

  const props = withDefaults(
    defineProps<{
      model: ModelItem;
      isSelected: boolean;
      canRename?: boolean;
      canDelete?: boolean;
    }>(),
    { canRename: true, canDelete: true }
  );

  const emit = defineEmits<{
    'toggle-selection': [id: number];
    rename: [model: ModelItem];
    delete: [model: ModelItem];
  }>();

  const router = useRouter();

  const hiddenActions = computed<RecordAction[]>(() => [
    ...(props.canRename ? [] : (['rename'] as RecordAction[])),
    ...(props.canDelete ? [] : (['delete'] as RecordAction[])),
  ]);

  function handleAction(action: RecordAction): void {
    if (action === 'view') {
      router.push({
        name: 'GestaoRegistrosModeloVisualizar',
        params: { id: props.model.id },
      });
      return;
    }

    if (action === 'edit') {
      router.push({ name: 'EditarModelo', params: { id: props.model.id } });
      return;
    }

    if (action === 'rename') {
      emit('rename', props.model);
      return;
    }

    if (action === 'delete') {
      emit('delete', props.model);
    }
  }
</script>

<template>
  <tr class="table-row-hover border-t border-gray-02 transition-colors duration-300 ease-out">
    <td class="pl-4 pr-2 py-4.5 align-middle leading-[0]">
      <Checkbox
        :id="model.id"
        :checked="isSelected"
        @toggle="emit('toggle-selection', model.id)"
      />
    </td>
    <!-- Título -->
    <td class="py-4.5 text-sm text-gray-07 text-left align-middle whitespace-nowrap min-w-96">
      {{ model.title }}
    </td>
    <!-- Categorias -->
    <td class="pl-6 py-4.5 text-left align-middle w-full">
      <div class="flex flex-wrap items-center gap-2 max-w-md">
        <Chip
          v-for="category in model.categories"
          :key="category.id"
          :label="category.name"
          :removable="false"
        />
      </div>
    </td>
    <!-- Ações -->
    <RecordActionsCell
      :hidden-actions="hiddenActions"
      @action="handleAction"
    />
  </tr>
</template>
